import React, { useContext } from 'react';
import { MenuGroup, MenuGroupProps, forwardRef } from '@chakra-ui/react';
import { getActionMenuGroupStyles } from './action-menu-group.theme';
import { ActionMenuContext } from './action-menu-context';

export type ActionMenuGroupProps = MenuGroupProps;

/**
 * The `ActionMenuGroup` component creates groupings of `ActionListItem`
 * components. If there are multiple `ActionMenuGroup` components within a
 * `ActionMenuContent` component they will be separated with a divider.
 */
export const ActionMenuGroup = forwardRef<ActionMenuGroupProps, 'div'>(
  ({ children, ...rest }, ref) => {
    const { colorMode } = useContext(ActionMenuContext);
    return (
      <MenuGroup ref={ref} sx={getActionMenuGroupStyles(colorMode)} {...rest}>
        {children}
      </MenuGroup>
    );
  }
);
